import { defineComponent as _defineComponent } from 'vue'
import { openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, createElementBlock as _createElementBlock } from "vue"

import ErrorState from './ErrorState.vue'
import Progress from './Progress.vue'

interface Props {
    hasError: boolean
    isPortal: boolean
    adType: 'interstitial' | 'rewarded' | null
}


export default /*@__PURE__*/_defineComponent({
  __name: 'BrandPreloader',
  props: {
    hasError: { type: Boolean },
    isPortal: { type: Boolean },
    adType: {}
  },
  emits: ["close"],
  setup(__props: any, { emit: __emit }) {

const props = __props

const emit = __emit

function handleClose() {
    if (props.hasError) {
        emit('close')
    }
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass([_ctx.$style.preloader, { [_ctx.$style.clickable]: _ctx.hasError }]),
    onClick: handleClose
  }, [
    (_ctx.hasError)
      ? (_openBlock(), _createBlock(ErrorState, {
          key: 0,
          adType: _ctx.adType
        }, null, 8, ["adType"]))
      : (_openBlock(), _createBlock(Progress, {
          key: 1,
          isPortal: _ctx.isPortal
        }, null, 8, ["isPortal"]))
  ], 2))
}
}

})